import { BrowserModule } from '@angular/platform-browser'
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { provideZoneChangeDetection } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NotificationModalComponent } from './shared/components/modal/notification-modal/notification-modal.component';
import { SharedModule } from './shared/shared.module';
import { AuthenticationModule } from './authentication/authentication.module';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from 'src/environments/environment';
import { PageModule } from './pages/page.module';
import { FEATURE_ROLE_MAPPING } from './shared/constants';
import { ApiModule, Configuration, ConfigurationParameters } from './core/api/v1';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

const getConfig = () => {
  const request = new XMLHttpRequest();
  request.open('GET', `${environment.serviceUrl}/api/config`, false);
  request.send(null);
  return JSON.parse(request.responseText);
}
const featuresRolesMapping = getConfig();

const configurationFactory = (): Configuration => {
  const configParams: ConfigurationParameters = {
    basePath: environment.serviceUrl
  };
  return new Configuration(configParams);
}


@NgModule({
  declarations: [
    AppComponent,
    NotificationModalComponent
  ],
  imports: [
    ApiModule.forRoot(configurationFactory),
    BrowserModule,
    CommonModule,
    RouterModule,
    AppRoutingModule,
    AuthenticationModule,
    SharedModule.forRoot(configurationFactory),
    PageModule,
    BrowserAnimationsModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    })
  ],
  providers: [
    provideZoneChangeDetection(),
    provideHttpClient(withInterceptorsFromDi()),
    { provide: FEATURE_ROLE_MAPPING, useValue: featuresRolesMapping }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
